module.exports = __webpack_public_path__ + "static/media/uniqueJobTitlesIcon.bef92e8f.svg";